<nav #navbar class="navbar navbar-default">
    <div class="container-fluid">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar bar1"></span>
                <span class="icon-bar bar2"></span>
                <span class="icon-bar bar3"></span>
            </button>
        </div>
        <div class="collapse navbar-collapse">
            <div class="" *ngIf="isMobileMenu()">
                <!-- <form class="navbar-form navbar-left navbar-search-form" role="search">
                    <div class="input-group">
                        <input type="text" value="" class="form-control" placeholder="Search...">
                        <span class="input-group-addon"><i class="fa fa-search"></i></span>
                    </div>
                </form> -->
                <ul class="nav navbar-nav navbar-right">
                    <li>
                        <a *ngIf="showStoreListBtn" class="btn btn-sm" (click)="showCompanyList()" style="float: left;">
                            <img style="width: 20px;"
                                src="../../assets/img/icon/menu-direito-superior-lojas.svg" />&nbsp;
                            Alterar Empresa
                        </a>
                        <!-- <a *ngIf="showStoreListBtn" class="btn btn-fill" (click)="showStoreList()" style="float: left;">
                            Alterar de Lojas
                        </a> -->
                        <a *ngIf="isAdmin" class="btn btn-fill btn-sm" style="float: left;" (click)="desimpersonate()">
                            Voltar ao Admin
                        </a>
                    </li>
                    <li>
                        <div class="dropdown">
                            <div class="company-logo">{{nameInitials}}</div>
                            <div class="btn-config-menu">
                                <div class="company-text">
                                    <span class="main-text" *ngIf="accountName != null && accountName != ''">{{accountName}}<br></span>
                                    <span [class.store-name]="storeName != null && storeName.length > 20">{{storeName!=="null" ? storeName : "Sem nome"}}</span>
                                </div>
                                <i style="font-size: 22px;margin-top: -9px;margin-left: 20px;" class="fas fa-sort-down"></i>                                
                            </div>
                            <div class="app-select-menu dropdown-content dropdown-menu-right">
                                <div class="app-select-container">
                                    <div><a href="/#/profile/perfil" aria-current="page"
                                            class="cursor-pointer app-select-link active">
                                            <div class="app-active-icon"></div>
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-dados-da-empresa.svg"><span>Dados
                                                    da Empresa</span>
                                            </div>
                                        </a></div>
                                        <div *ngIf="profilePlan != null && profilePlan.planSeoName == 'free'">
                                            <a href="/#/profile/balance" aria-current="page"
                                            class="cursor-pointer app-select-link active">
                                            <div class="app-active-icon"></div>
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-faturas.svg"><span>Adicionar Créditos</span>
                                            </div>
                                        </a></div>
                                    <div><a href="/#/profile/billing" aria-current="page"
                                            class="cursor-pointer app-select-link active">
                                            <div class="app-active-icon"></div>
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-plano.svg"><span>Plano/Financeiro</span>
                                            </div>
                                        </a></div>
                                    <div><a href="/#/profile/users" class="cursor-pointer app-select-link">
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-lojas.svg"><span>Usuários</span>
                                            </div>
                                        </a></div>
                                    <div><a href="/#/setup" class="cursor-pointer app-select-link">
                                            <div class="app-active-icon"></div>
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-setup.svg"><span>Setup</span>
                                            </div>
                                        </a></div>
                                    <div><a href="/#/api" class="cursor-pointer app-select-link">
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-api.svg"><span>API</span>
                                            </div>
                                        </a></div>
                                    <div><a href="/#/profile/invoices" class="cursor-pointer app-select-link">
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-faturas.svg"><span>Faturas</span>
                                            </div>
                                        </a></div>
                                    <div><a href="https://polen.com.br/faq" target="_blank"
                                            class="cursor-pointer app-select-link">
                                            <div class="app-active-icon"></div>
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-faq.svg"><span>FAQ</span>
                                            </div>
                                        </a></div>
                                    <div><a (click)="logout()" class="cursor-pointer app-select-link">
                                            <div class="app-active-icon"></div>
                                            <div class="app-select-item"><img
                                                    src="../../assets/img/icon/menu-direito-superior-sair.svg"><span>Sair</span>
                                            </div>
                                        </a></div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>
